import React from 'react';
import { connect } from 'react-redux';
import '../../assets/styles/pages/my-account/my-account.scss';
import Portfolio from '../../components/MyAccount/Portfolio/Portfolio';
import classNames from 'classnames';
import '../../assets/styles/pages/trading-page.scss';
import CashAccount from '@/components/@app/CashAccount/CashAccount';
import Instrument from '../../components/Instrument/Instrument';
import OrderBook from '../../components/OrderTable/OrderBook';
import OrderHistory from '../../components/OrderTable/OrderHistory';
import TabHeader from '../../components/TabHeader/TabHeader';
import { accountActions } from '@/actions/trading/account.actions';
import { PARAMS } from '@/constants/params';
import LoadingLayer from '@/../src/components/Spinner/LoadingLayer';
import { CUSTOM_STYLES } from '@/constants/app';
import { stockActions } from '@/actions/trading/stock.action';

import { PostMsg } from '../../assets/aastock_libs/postmessage';
import { getSafe } from '@/helpers/global';
import { store } from '@/configurations'

const ORDER_BOOK_TABLE = 3;
const ORDER_HISTORY_TABLE = 4;
const PORTFOLIO_TABLE = 2;

class Trade extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderTableTab: ORDER_BOOK_TABLE,
      orderTableTabList: [
        { id: 9, title: 'order_book_title', isActive: true },
        { id: 8, title: 'order_history_title' },
        // { id: 7, title: 'portfolio_title', configID: ctrlID.accountCtrl }
      ],
      maximumDate: {},
      searchParams: {
        status: '',
        startDate: '',
        endDate: '',
        instrumentID:''
      },
      aaStockUrl: '',
      load: true,
      aaStock: [{
        id: '1', title: 'market_info', isActive: false
      }],
      hkBt:true,
      szBt:false,
      maBt:false,
      marketID:'HKEX',
      marketInfoList:[]
    }
    this.enabledAccount = false
  }

  render() {
    const { orderTableTab, orderTableTabList, maximumDate, load, aaStock, hkBt, maBt, szBt } = this.state;
    const { language } = this.props;
    return (
      <React.Fragment>
        <div className='trading-container'>
          <div className="left">
            <section className={classNames('tow-colum')}>
                <React.Fragment>
                  <div className="left-content">
                    <TabHeader refresh customStyle={CUSTOM_STYLES.HEADER_NORMAL} onRefresh={() => this.getAAStock()} />
                    <div className="market-box">
                      <button value='HKEX' className={ hkBt ? 'select-button ':'not-select-button '} onClick={e => this.selectQuoteMarket(e)}>{getSafe(() => language.common_market_hk)}</button>
                      <button value='MAMK' className={ maBt ? 'select-button ':'not-select-button '} onClick={e => this.selectQuoteMarket(e)}>{getSafe(() => language.common_market_ma)}</button>
                      <button value='SZMK' className={ szBt ? 'select-button ':'not-select-button '} onClick={e => this.selectQuoteMarket(e)}>{getSafe(() => language.common_market_sz)}</button>
                    </div>
                    <LoadingLayer load={load} />
                    <iframe id="TRADE" onLoad={() => this.bringPrice() } className="customer-frame" src={this.state.aaStockUrl}></iframe>
                  </div>
                  <section className="right-content">
                    <Instrument p_Identifier={this.props.p_Identifier} innerRef={e => this.InstrumentRef = e} TradeDashboard={true}/>
                  </section>
                </React.Fragment>
            </section>
            <section className="order-table">
              <TabHeader
                innerRef={e => this.tabHeaderOrderRef = e}
                tabs={orderTableTabList}
                onChange={this.handleChangeOrderTableTab}
                orderFilterDropdown={orderTableTab !== PORTFOLIO_TABLE}
                codeInput={orderTableTab !== PORTFOLIO_TABLE}
                onSelectOrderFilter={this.handleFilter}
                onInputCodeFilter={this.handleInputCodeFilter}
                dateRangePicker={orderTableTab === ORDER_HISTORY_TABLE}
                maximumDate={maximumDate}
                onChangeDatePicker={this.handleChangeDatePicker}
                refresh
                haveActions={true}
                onRefresh={this.handleSearchData}
                marketFilter={orderTableTab === PORTFOLIO_TABLE}
                onChangeMarket={this.handleChangeMarket}
              />
              {orderTableTab === ORDER_BOOK_TABLE && <OrderBook innerRef={e => this.orderBookRef = e} />}
              {orderTableTab === ORDER_HISTORY_TABLE && <OrderHistory innerRef={e => this.orderHistoryRef = e} />}
              {orderTableTab === PORTFOLIO_TABLE && <Portfolio tabHeader={false} innerRef={e => this.portfolioRef = e} />}
            </section>
          </div>
          {
            this.enabledAccount &&
            <div className="right">
              <section className="asset">
                <CashAccount />
              </section>
              <section className="stock-infor">
                <Instrument p_Identifier={this.props.p_Identifier} innerRef={e => this.InstrumentRef = e} />
              </section>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }

  handleChangeMarket = (market) => {
    if (market) {
      this.portfolioRef.handleChangeMarket(market)
    }
  }

  selectQuoteMarket(e){
    this.setState({
      load: true
    })
    let marketID = e.target.value
    if(marketID === 'HKEX'){
      this.setState({
        hkBt:true,
        szBt:false,
        maBt:false
      })
    }else if(marketID === 'MAMK'){
      this.setState({
        hkBt:false,
        szBt:false,
        maBt:true
      })
    }else if(marketID === 'SZMK'){
      this.setState({
        hkBt:false,
        szBt:true,
        maBt:false
      })
    }
    if(this.state.marketInfoList.length>0){
      this.state.marketInfoList.map(item =>{
        if(item.market === marketID){
          this.setState({
            aaStockUrl: item.url,
            marketID:marketID
          })
        }
      })
    }
  }

  handleChangeDatePicker = (date) => {
    const startDate = this.convertDateObjectToString(date.from);
    const endDate = this.convertDateObjectToString(date.to);
    const { searchParams } = this.state;
    if (startDate !== searchParams.startDate || endDate !== searchParams.endDate) {
      this.setState({
        searchParams: Object.assign({}, searchParams,
          {
            startDate,
            endDate
          })
      }, () => this.handleSearchData())
    }
  }

  handleFilter = (key) => {
    const { searchParams } = this.state;
    switch (key) {
      case 'all': {
        this.setState({ searchParams: Object.assign({}, searchParams, { status: '' }) }, () => {
          this.handleSearchData();
        })
        break;
      }
      default: {
        this.setState({ searchParams: Object.assign({}, searchParams, { status: key.toUpperCase() }) }, () => {
          this.handleSearchData();
        })
        break;
      }
    }
  }

  handleInputCodeFilter = (code) => {
    const { searchParams } = this.state;
    if(code){
      this.setState({
        searchParams: Object.assign({}, searchParams, { instrumentID: code })
      }, () => {
        this.handleSearchData();
      })
    }else{
      this.setState({ searchParams: Object.assign({}, searchParams, { instrumentID: '' }) }, () => {
        this.handleSearchData();
      })
    }
  }

  handleSearchData = () => {
    const { orderTableTab, searchParams } = this.state;
    const { status, startDate, endDate,instrumentID } = searchParams;
    let tableRef = null;
    if (orderTableTab === ORDER_BOOK_TABLE) {
      tableRef = this.orderBookRef;
    } else if (orderTableTab === ORDER_HISTORY_TABLE) {
      tableRef = this.orderHistoryRef;
    } else if (orderTableTab === PORTFOLIO_TABLE) {
      this.portfolioRef.getPortfolio()
    }
    if (tableRef) {
        tableRef.getData(status, startDate, endDate,instrumentID,true)
    }
  }

  handleChangeOrderTableTab = (tab) => {
    switch (tab.main.title) {
      case 'order_book_title': {
        this.setState({
          orderTableTab: ORDER_BOOK_TABLE,
          searchParams: {
            status: '',
            startDate: '',
            endDate: ''
          }
        },() => {
          this.tabHeaderOrderRef.resetOrderFilterDropdown();
          this.tabHeaderOrderRef.resetCodeInput();
        })
        break;
      }
      case 'order_history_title': {
        const maximumDate = this.getMaximumDate();
        this.setState({
          orderTableTab: ORDER_HISTORY_TABLE,
          searchParams: {
            status: '',
            startDate: this.convertDateObjectToString(maximumDate),
            endDate: this.convertDateObjectToString(maximumDate)
          }
        }, () => {
          this.tabHeaderOrderRef.setDatePickerValue(maximumDate);
          this.tabHeaderOrderRef.resetOrderFilterDropdown();
          this.tabHeaderOrderRef.resetCodeInput();
        })
        break;
      }
      case 'portfolio_title': {
        this.setState({
          orderTableTab: PORTFOLIO_TABLE,
        })
        break;
      }
      default: break;
    }
  }

  convertDateObjectToString(date) {
    return `${date.year}-${date.month}-${date.day}`
  }

  getMaximumDate() {
    let date = new Date();
    date.setDate(date.getDate() - 1); // get yesterday
    const maximumDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    }
    this.setState({ maximumDate })
    return maximumDate;
  }

  componentDidMount() {
    this.getMaximumDate();
    this.initConfigTableHeader()
    this.getAAStock()
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      this.handleSearchData();
      this.getAAStock()
    }
    if (this.props.isNeedRefresh && this.props.isNeedRefresh !== prevProps.isNeedRefresh) {
      this.handleSearchData()
    }
    if (prevProps.language !== this.props.language) {
      this.handleSearchData()
      this.getAAStock()
    }
    if (this.props.token && this.props.token !== prevProps.token) {
      this.getAAStock()
    }
  }

  getAAStock() {
    const { language, currentTradingAccount, token } = this.props;
    let dataFeedClientName = store.getState().auth?.user?.external?.dataFeedClientName
    if(dataFeedClientName === false) return
    if (currentTradingAccount.clientID && token) {
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.AASTOCK_USER_ID]: dataFeedClientName
      }
      this.setState({
        load: true
      })
      this.props.getAAStock(params, res => {
        let marketInfoList = res.result.marketInfo
        if (marketInfoList.length > 0) {
          marketInfoList.map(item =>{
            if(item.market === this.state.marketID){
              this.setState({
                aaStockUrl: item.url
              })
            }
          })
          this.setState({
            marketInfoList: marketInfoList
          })
        } else {
          this.setState({
            load: false
          })
        }
      })
    }
    setTimeout(() => {
      this.setState({
        load: false
      })
    }, 10000);
  }

  bringPrice(){
    this.setState({ load: false },()=>{
      if(this.state.aaStockUrl){
        PostMsg.receiveMessage((e) => {
          var str = e.data;
          var res = str.split("&");

          var lvStock = "";
          var lvBuySell = "";
          var lvPrice = "";
          for (var i = 0; i < res.length; i++) {
            var lvTempValue = "";
            var lvRes = res[i].split("=");
            var lvResTemp = lvRes[0];
            var lvResTemp1 = lvRes[1];

            if (lvResTemp.indexOf("stock") >= 0) {
              lvStock = lvResTemp1;
            }
            if (lvResTemp.indexOf("buySell") >= 0) {
              lvBuySell = lvResTemp1;
            }
            if (lvResTemp.indexOf("price") >= 0) {
              lvPrice = lvResTemp1;
            }
          }
          this.InstrumentRef.copyPrice(lvPrice)
          this.props.setStock({ stockCode: lvStock, marketID: this.state.marketID })
          window.top.mainFrame.OrderFrame.setStockCode(lvStock);
          window.top.mainFrame.OrderFrame.setPrice(lvPrice);
        }, this.state.aaStockUrl)
      }
    })
  }

  initConfigTableHeader() {
    let arr = []
    this.state.orderTableTabList.map(item => {
      if (item.configID) {
        if (this.props.p_Identifier.child.includes(item.configID)) {
        } else {
          return arr.push(item)
        }
      } else {
        return arr.push(item);
      }

    })
    this.setState({
      orderTableTabList: arr
    })
  }

}

Trade.defaultProps = {
  p_Identifier: {
      id: 'trade',
      child: []
  }
}
export default connect(
  state => ({
    currentTradingAccount: state.trade.currentTradingAccount,
    isNeedRefresh: state.refresh.orderTable,
    language: state.app.language,
    token: state.auth.token
  }),
  dispatch => ({
    getAAStock: (p, res) => dispatch(accountActions.getAAStockAction(p, res)),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
  })
)(Trade)
